import { Link } from 'wouter-preact'

import { ChevronLeftIcon, Typography } from 'components'
import { isProjectLoadingState, projectDetailsState } from 'state'
import { formatDate } from 'utils'

const ProjectDetailsSection = () => (
	<div class='flex items-center justify-between'>
		<div>
			<Link
				class='mb-1 flex items-center gap-2 text-black-400 hover:text-product'
				href='~/'
			>
				<ChevronLeftIcon />
				<Typography
					class='mt-[1px]'
					color='text-black-400'
					text='Back to Home'
					variant='text3'
				/>
			</Link>

			<Typography
				color='text-black-100'
				text={projectDetailsState.value!.name}
				variant='h2'
			/>
		</div>
		<div class='flex gap-16'>
			<div>
				<Typography
					color='text-black-400'
					text='Project ID:'
					variant='label4'
				/>
				<Typography
					loading={isProjectLoadingState.value}
					loadingClass='bg-black-600'
					text={projectDetailsState.value?.publicId ?? '&nbsp;'}
					variant='text2'
				/>
			</div>
			<div>
				<Typography color='text-black-400' text='Created:' variant='label4' />
				<Typography
					loading={isProjectLoadingState.value}
					loadingClass='bg-black-600'
					text={formatDate(projectDetailsState.value?.createdAt)}
					variant='text2'
				/>
			</div>
		</div>
	</div>
)

export { ProjectDetailsSection }
